import {
    GET_EVENT_DATA,
    GET_MESSAGES_FAILURE,
    GET_MESSAGES_REQUEST,
    GET_MESSAGES_SUCCESS,
    GET_RESPONSE_FAILURE,
    GET_RESPONSE_SUCCESS,
    GET_USERS_SUCCESS, ON_CONNECT,
    ON_CONNECT_SUCCESS,
    ON_DISCONNECT,
    POST_MESSAGE_REQUEST,
    RESET_MESSAGES,
    RESET_STATE,
    SET_DENTIST,
    GET_CHAT_DENTISTS_SUCCESS
} from "./constants";
import _ from 'lodash';

const initialState = {
    onlineUsers: [],
    messages: [],
    adminIsOnline: false,
    numberOfMessages: 0,
    error: '',
    dentists: [],
    noMoreMessages: false,
    page: null,
    partnerId: null,
    reconnected: false,
    addedMessage: false,
    connected: false,
    currentDentist: {},
    maxChat: false,
    chatDentists: []
};

const chatReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_EVENT_DATA: {
            const messages = Object.assign([], state.messages);
            let dentists = Object.assign([], state.dentists);
            let chatDentists = Object.assign([], state.chatDentists);
            if (action.data.message) {
                if(state.partnerId === action.data.message.from.toString()) {
                    messages.push(action.data.message);
                }
                dentists = state.dentists.map(item => {
                    if (item.id === action.data.message.to || item.id === action.data.message.from) {
                        return Object.assign({}, item, {
                            message_id: action.data.message.id,
                            message_date: action.data.message.created_at,
                            message: action.data.message.message,
                            message_from: action.data.message.from,
                            is_read: action.data.message.is_read,
                        });
                    }
                    return item;
                });
                chatDentists = state.chatDentists.map(item => {
                    if (item.id === action.data.message.to || item.id === action.data.message.from) {
                        return Object.assign({}, item, {
                            unread_messages_count: item.unread_messages_count+1
                        });
                    }
                    return item;
                })
            }
            let numberOfMessages = state.numberOfMessages;
            if (action.event === 'getMessage' && !action.data.numberOfMessages) {
                numberOfMessages += 1;
            }
            
            return Object.assign({}, state, {
                onlineUsers: action.data.users ? Object.keys(action.data.users.users)
                    .filter(userId => !_.isEmpty(action.data.users.users[userId])) : state.onlineUsers,
                numberOfMessages,
                adminIsOnline: action.data.users ? !!Object.keys(action.data.users.admins['1']).length : state.adminIsOnline,
                messages,
                dentists,
                chatDentists,
                newMessages: action.data.message,
                reconnected: action.data.event === 'connect' ?  action.data.connected: false
            });
        }
        case GET_RESPONSE_SUCCESS: {
            const messages = state.messages;
            let dentists = state.dentists;
            if (action.data.message) {
                if(action.event === 'read') {
                   const messageIndex =  messages.findIndex(item => item.id === action.data.message.id);
                    messages[messageIndex] = action.data.message;
                } else {
                    messages.push(action.data.message);
                }
                dentists = state.dentists.map(item => {
                    if (item.id === action.data.message.to || item.id === action.data.message.from) {
                        return Object.assign({}, item, {
                            message_id: action.data.message.id,
                            message_date: action.data.message.created_at,
                            message: action.data.message.message,
                            message_from: action.data.message.from,
                            is_read: action.data.message.is_read
                        });
                    }
                    return item;
                });
            }
            return Object.assign({}, state, {
                
                onlineUsers: action.event === 'leave' ? [] : action.data.users ? Object.keys(action.data.users.users)
                    .filter(userId => !_.isEmpty(action.data.users.users[userId])) : state.onlineUsers,
                numberOfMessages: action.data.numberOfMessages >= 0 ? action.data.numberOfMessages : state.numberOfMessages,
                unread_messages_count: 0,
                adminIsOnline: action.data.users ? !!Object.keys(action.data.users.admins['1']).length : state.adminIsOnline,
                messages,
                dentists,
                maxChat: true,
                addedMessage: action.event === 'message'
            });
        }
        case GET_RESPONSE_FAILURE: {
            return Object.assign({}, state, {
                error: action.data.statusCode ? `Server responded with a ${action.data.statusCode} status code.` : ''
            });
        }
        case POST_MESSAGE_REQUEST: {
            return Object.assign({}, state, {addedMessage: false});
        }
        case GET_MESSAGES_REQUEST: {
            return Object.assign({}, state, {
                loadingMessages: true
            });
        }
        case GET_MESSAGES_SUCCESS: {
            let messages = state.messages;
            if(state.partnerId === action.data.partnerId && state.page !== action.data.page) {
                messages = action.data.messages.concat(state.messages);
            } else {
                messages = action.data.messages;
            }
            return Object.assign({}, state, {
                messages: messages,
                loadingMessages: false,
                noMoreMessages: action.data.messages.length === 0,
                partnerId: action.data.partnerId,
                page: action.data.page,
            });
        }
        case GET_MESSAGES_FAILURE: {
            return Object.assign({}, state, {
                error: action.data.error.message,
                loadingMessages: false
            });
        }
        case RESET_MESSAGES: {
            return Object.assign({}, state, {
                messages: []
            });
        }
        case GET_USERS_SUCCESS: {
            return Object.assign({}, state, {
                dentists: action.data.dentists
            });
        }
        case RESET_STATE: {
            return Object.assign({}, state, {
                messages: [],
                noMoreMessages: false,
                page: null,
                partnerId: null,
                error: ''
            })
        }
        case ON_CONNECT_SUCCESS: {
            return Object.assign({}, state, {
                connected: true
            })
        }
        case ON_CONNECT: {
            return Object.assign({}, state, {
                connected: false
            })
        }
        case ON_DISCONNECT: {
            return Object.assign({}, state, {
                connected: false
            })
        }
        case SET_DENTIST: {
            return Object.assign({}, state, {
                currentDentist: action.data
            })
        }
        case GET_CHAT_DENTISTS_SUCCESS: {
            return Object.assign({}, state, {
               chatDentists: action.data
            });
        }
        default: {
            return Object.assign({}, state, {error: ''});
        }
    }
}

export default chatReducer;



// WEBPACK FOOTER //
// ./src/containers/Chat/reducer.js